export class UserActivity {
  firstActivityDate: Date = new Date()
  lastActivityDate: Date = new Date()
  blockedUsersModifiedAt: Date = new Date()
}
